<div class="wrap">

    <p>
        <b>Все:</b>
        <span (click)="changeSettings('total', 'total', widget)"
              [class]="checkContainsInTaskFilterWidget('total', 'total', widget) ? 'text-bg-info' : 'text-bg-light'"
              class="badge badge-pill m-1"
              style="cursor: pointer;"
        >
                                 Все
                                </span>
    </p>

    <p>
        <b>Важность:</b>
        <span (click)="changeSettings('importance', 'NORMAL', widget)"
              [class]="checkContainsInTaskFilterWidget('importance', 'NORMAL', widget) ?
                                                'text-bg-info' : 'text-bg-light'"
              class="badge badge-pill m-1"
              style="cursor: pointer;"
        >
                                 Обычная
                                </span>
        <span (click)="changeSettings('importance', 'MIDDLE', widget)"
              [class]="checkContainsInTaskFilterWidget('importance', 'MIDDLE', widget) ?
                                                'text-bg-info' : 'text-bg-light'"
              class="badge badge-pill m-1"
              style="cursor: pointer;"
        >
                                 Важная
                                </span>
        <span (click)="changeSettings('importance', 'IMPORTANT', widget)"
              [class]="checkContainsInTaskFilterWidget('importance', 'IMPORTANT', widget) ?
                                                'text-bg-info' : 'text-bg-light'"
              class="badge badge-pill m-1"
              style="cursor: pointer;"
        >
                                 Срочная
                                </span>
    </p>

    <p>
        <b>Роль:</b>
        <span (click)="changeSettings('role', 'author', widget)"
              [class]="checkContainsInTaskFilterWidget('role', 'author', widget) ?
                                                'text-bg-info' : 'text-bg-light'"
              class="badge badge-pill m-1"
              style="cursor: pointer;"
        >
                                    {{ 'TASKS.TEXT.ROLES.author' | translate }}
                                </span>
        <span (click)="changeSettings('role', 'executor', widget)"
              [class]="checkContainsInTaskFilterWidget('role', 'executor', widget) ?
                                                'text-bg-info' : 'text-bg-light'"
              class="badge badge-pill m-1"
              style="cursor: pointer;"
        >
                                    {{ 'TASKS.TEXT.ROLES.executor' | translate }}
                                </span>
        <span (click)="changeSettings('role', 'observer', widget)"
              [class]="checkContainsInTaskFilterWidget('role', 'observer', widget) ?
                                                'text-bg-info' : 'text-bg-light'"
              class="badge badge-pill m-1"
              style="cursor: pointer;"
        >
                                    {{ 'TASKS.TEXT.ROLES.observer' | translate }}
                                </span>
        <span (click)="changeSettings('role', 'responsible', widget)"
              [class]="checkContainsInTaskFilterWidget('role', 'responsible', widget) ?
                                                'text-bg-info' : 'text-bg-light'"
              class="badge badge-pill m-1"
              style="cursor: pointer;"
        >
                                    {{ 'TASKS.TEXT.ROLES.responsible' | translate }}
                                </span>
        <span (click)="changeSettings('role', 'observer_contract', widget)"
              [class]="checkContainsInTaskFilterWidget('role', 'observer_contract', widget) ?
                                                'text-bg-info' : 'text-bg-light'"
              class="badge badge-pill m-1"
              style="cursor: pointer;"
        >
                                    {{ 'TASKS.TEXT.ROLES.observer_contract' | translate }}
                                </span>
    </p>

    <div class="accordion">
        <b>Бизнес-процессы:</b>
        <div *ngFor="let dash of widget.content.dashes"
             [id]="'accordion' + dash.alias"
             class="accordion-item"
        >

            <h2 class="accordion-header">
                <button [attr.aria-controls]="'panelsStayOpen-' + dash.alias"
                        [attr.data-bs-target]="'#panelsStayOpen-' + dash.alias"
                        aria-expanded="false"
                        class="accordion-button collapsed"
                        data-bs-toggle="collapse"
                        type="button"
                >
                    <b>{{ dash.alias }}:</b>
                </button>
            </h2>

            <div [id]="'panelsStayOpen-' + dash.alias"
                 class="accordion-collapse collapse"
            >
                <div class="accordion-body">
                    <p>
                                                <span (click)="changeSettings('total', 'total', widget, dash.alias)"
                                                      [class]="checkContainsInTaskFilterWidget('total', 'total', widget, dash.alias) ?
                                                                'text-bg-info' : 'text-bg-light'"
                                                      class="badge badge-pill m-1"
                                                      style="cursor: pointer;"
                                                >
                                                    Все
                                                </span>
                    </p>
                    <p>
                        <b>Роль</b>

                        <span (click)="changeSettings('role', 'author', widget, dash.alias)"
                              [class]="checkContainsInTaskFilterWidget('role', 'author', widget, dash.alias) ?
                                                                  'text-bg-info' : 'text-bg-light'"
                              class="badge badge-pill m-1"
                              style="cursor: pointer;"
                        >
                                                    {{ 'TASKS.TEXT.ROLES.author' | translate }}
                                                </span>
                        <span (click)="changeSettings('role', 'executor', widget, dash.alias)"
                              [class]="checkContainsInTaskFilterWidget('role', 'executor', widget, dash.alias) ?
                                                                 'text-bg-info' : 'text-bg-light'"
                              class="badge badge-pill m-1"
                              style="cursor: pointer;"
                        >
                                                    {{ 'TASKS.TEXT.ROLES.executor' | translate }}
                                                </span>
                        <span (click)="changeSettings('role', 'observer', widget, dash.alias)"
                              [class]="checkContainsInTaskFilterWidget('role', 'observer', widget, dash.alias) ?
                                                                'text-bg-info' : 'text-bg-light'"
                              class="badge badge-pill m-1"
                              style="cursor: pointer;"
                        >
                                                    {{ 'TASKS.TEXT.ROLES.observer' | translate }}
                                                </span>
                        <span (click)="changeSettings('role', 'responsible', widget, dash.alias)"
                              [class]="checkContainsInTaskFilterWidget('role', 'responsible', widget, dash.alias) ?
                                                                'text-bg-info' : 'text-bg-light'"
                              class="badge badge-pill m-1"
                              style="cursor: pointer;"
                        >
                                                    {{ 'TASKS.TEXT.ROLES.responsible' | translate }}
                                                </span>
                        <span (click)="changeSettings('role', 'observer_contract', widget, dash.alias)"
                              [class]="checkContainsInTaskFilterWidget('role',
                                                                                                'observer_contract',
                                                                                                 widget,
                                                                                                 dash.alias
                                                                                                 ) ? 'text-bg-info' : 'text-bg-light'"
                              class="badge badge-pill m-1"
                              style="cursor: pointer;"
                        >
                                                     {{ 'TASKS.TEXT.ROLES.observer_contract' | translate }}
                                                </span>
                    </p>
                    <p>
                        <b>Важность:</b>
                        <span (click)="changeSettings('importance', 'NORMAL', widget, dash.alias)"
                              [class]="checkContainsInTaskFilterWidget('importance', 'NORMAL', widget, dash.alias) ?
                                                               'text-bg-info' : 'text-bg-light'"
                              class="badge badge-pill m-1"
                              style="cursor: pointer;"
                        >
                                                    Обычная
                                                </span>
                        <span (click)="changeSettings('importance', 'MIDDLE', widget, dash.alias)"
                              [class]="checkContainsInTaskFilterWidget('importance', 'MIDDLE', widget, dash.alias) ?
                                                                'text-bg-info' : 'text-bg-light'"
                              class="badge badge-pill m-1"
                              style="cursor: pointer;"
                        >
                                                    Важная
                                                </span>
                        <span (click)="changeSettings('importance', 'IMPORTANT', widget, dash.alias)"
                              [class]="checkContainsInTaskFilterWidget('importance',
                                                                                    'IMPORTANT', widget, dash.alias) ?
                                                                'text-bg-info' : 'text-bg-light'"
                              class="badge badge-pill m-1"
                              style="cursor: pointer;"
                        >
                                                    Срочная
                                                </span>
                    </p>
                    <p>
                        <b>Статус:</b>
                        <span (click)="changeSettings('status', status.id, widget, dash.alias)"
                              *ngFor="let status of dash.status_nodes"
                              [class]="checkContainsInTaskFilterWidget('status', status.id, widget, dash.alias) ?
                                                               'text-bg-info' : 'text-bg-light'"
                              class="badge badge-pill m-1"
                              style="cursor: pointer;"
                        >
                                                    {{ status.label }}
                                                </span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
